import { PropsWithChildren } from 'react'
import Image from 'next/image'

interface HeroProps extends PropsWithChildren {
  title: string
  titleHighlighted?: string
  description: string
}

export const Hero = ({ title, titleHighlighted, description, children }: HeroProps) => {
  return (
    <div className='relative mx-auto min-h-[680px] w-full max-w-3xl px-4 pt-[200px] lg:max-w-7xl'>
      <Image
        src='https://scalis-assets.s3.us-east-2.amazonaws.com/public/landing/scalis-ladder.svg'
        alt='Scalis Ladder'
        width={72}
        height={72}
        quality={100}
        priority
        draggable={false}
        className='mx-auto h-12 w-12 lg:h-[72px] lg:w-[72px]'
      />
      <h1 className='mt-8 whitespace-normal text-center text-5xl font-semibold lg:text-7xl! relative'>
        <span className='absolute right-32 top-1/2 shadow-[0_0_512px_256px_rgb(201,213,251,.5)]' />
        {title}
        {titleHighlighted && (
          <>
            {' '}
            <span className='relative text-5xl font-bold text-brand-primary-rest lg:text-7xl! '>
              {titleHighlighted}
            </span>
          </>
        )}
      </h1>
      <p className='mt-8 max-w-7xl text-center text-base font-normal tracking-tight text-neutral-secondary lg:text-xl lg:font-medium'>
        {description}
      </p>
      {children}
    </div>
  )
}
